import usePageContent from '../utils/usePageContent';
import Services from '../components/Services';

const images = [
  "/images/services-section/Service10.jpg"
];

const Service = () => {
  const { title, description } = usePageContent('service');

  return (
    <div className="main-about">
      <div
        className="relative w-full h-[550px] bg-cover bg-center bg-gray-200 rounded-b-lg overflow-hidden"
        style={{ backgroundImage: `url(${images[0]})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="text-center text-white px-4 md:px-8">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 inline-block relative after:content-[''] after:block after:w-full after:h-1 after:bg-red-700 after:mt-2">
              {title}
            </h2>
            <p className="text-xl md:text-2xl max-w-2xl mx-auto">{description}</p>
          </div>
        </div>
      </div>
      <div className="mt-18 px-24 text-black">
        <Services />
      </div>
    </div>
  );
};

export default Service;
